import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "17",
  r: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3C8.49 3 5.28 4.29 2.8 6.41c-.44.38-.48 1.06-.06 1.48l3.6 3.6c.36.36.92.39 1.32.08 1.2-.94 2.71-1.5 4.34-1.5 1.64 0 3.14.56 4.34 1.49.4.31.96.28 1.31-.08l3.6-3.6c.42-.42.38-1.1-.07-1.48C18.72 4.28 15.51 3 12 3z"
})), 'CompassCalibrationRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CompassCalibrationRounded.js
// module id = 2910
// module chunks = 2